// Shared nav-item visibility helper used by vertical, mini, and horizontal nav sections.

// Backward-compat: titles were shortened (e.g. "Consultation Booked" → "Booked"),
// but practices may still have the old slugs saved in hidden_nav_items.
const LEGACY_SLUG_ALIASES = {
    booked: 'consultation-booked',
    attended: 'consultation-attended',
    'reviews-&-feedback': 'reviews-&-listing',
    // Task O addendum: "Tasks" -> "Task Board" rename. A practice that had
    // previously hidden "Tasks" (slug 'tasks') would otherwise silently have it
    // reappear now that its slug is 'task-board' — same backward-compat pattern
    // as booked/attended above.
    'task-board': 'tasks',
    appointments: 'scheduling',
};

export const titleToSlug = (title) =>
    title?.toLowerCase?.().replace(/[()]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/-$/, '') || '';

export const isNavItemHidden = (slug, hiddenNavItems) => {
    if (!hiddenNavItems || hiddenNavItems.length === 0) return false;
    if (hiddenNavItems.includes(slug)) return true;
    if (LEGACY_SLUG_ALIASES[slug] && hiddenNavItems.includes(LEGACY_SLUG_ALIASES[slug])) return true;
    return false;
};
